<template>
  <form class="columns is-multiline">
    <div class="column is-12">
      <div class="field">
        <label class="label" for="ticket-subject">Asunto <span class="is-mandatory">*</span></label>
        <div class="control">
          <input
            id="ticket-subject"
            class="input"
            type="text"
            placeholder="Asunto"
            name="subject"
            v-model="subject"
            v-validate="'required'"
            data-vv-as="asunto"
            :class="{'is-danger': vverrors.has('subject')}"
          >
        </div>
        <p class="help is-danger">{{ vverrors.first('subject') }}</p>
      </div>
    </div>

    <div class="column is-6">
      <div class="field">
        <label class="label" for="ticket-module">Módulo afectado <span class="is-mandatory">*</span></label>
        <div class="control">
          <div class="select is-fullwidth" :class="{'is-danger': vverrors.has('moduleCode')}">
            <select
              id="ticket-module"
              v-model="moduleCode"
              name="moduleCode"
              v-validate="'required'"
              data-vv-as="módulo afectado"
            >
              <option :value="null" disabled>Seleccione una opción</option>
              <option v-for="option in moduleOptions" :key="option.code" :value="option.code">{{ option.label }}</option>
            </select>
          </div>
        </div>
        <p class="help is-danger">{{ vverrors.first('moduleCode') }}</p>
      </div>
    </div>

    <div class="column is-6">
      <div class="field">
        <label class="label" for="ticket-priority">Prioridad <span class="is-mandatory">*</span></label>
        <div class="control">
          <div class="select is-fullwidth" :class="{'is-danger': vverrors.has('priorityCode')}">
            <select
              id="ticket-priority"
              v-model="priorityCode"
              name="priorityCode"
              v-validate="'required'"
              data-vv-as="prioridad"
            >
              <option :value="null" disabled>Seleccione una opción</option>
              <option v-for="option in priorityOptions" :key="option.code" :value="option.code">{{ option.label }}</option>
            </select>
          </div>
        </div>
        <p class="help is-danger">{{ vverrors.first('priorityCode') }}</p>
      </div>
    </div>

    <div class="column is-6">
      <div class="field">
        <label class="label" for="ticket-type">Tipo <span class="is-mandatory">*</span></label>
        <div class="control">
          <div class="select is-fullwidth" :class="{'is-danger': vverrors.has('typeCode')}">
            <select
              id="ticket-type"
              v-model="typeCode"
              name="typeCode"
              v-validate="'required'"
              data-vv-as="tipo"
            >
              <option :value="null" disabled>Seleccione una opción</option>
              <option v-for="option in typeOptions" :key="option.code" :value="option.code">{{ option.label }}</option>
            </select>
          </div>
        </div>
        <p class="help is-danger">{{ vverrors.first('typeCode') }}</p>
      </div>
    </div>

    <div class="column is-12">
      <div class="field">
        <label class="label" for="ticket-description">Descripción <span class="is-mandatory">*</span></label>
        <div class="control">
          <textarea
            id="ticket-description"
            class="textarea"
            rows="4"
            name="description"
            placeholder="Describe el problema o solicitud con el mayor detalle posible"
            v-model="description"
            v-validate="'required'"
            data-vv-as="descripción"
            :class="{'is-danger': vverrors.has('description')}"
          ></textarea>
        </div>
        <p class="help is-danger">{{ vverrors.first('description') }}</p>
      </div>
    </div>

    <div class="column is-12">
      <div class="field">
        <label class="label" for="ticket-case-url">URL del caso</label>
        <div class="control">
          <input
            id="ticket-case-url"
            class="input"
            type="url"
            placeholder="https://..."
            name="caseUrl"
            v-model="caseUrl"
          >
        </div>
      </div>
    </div>

    <div class="column is-12">
      <div class="field">
        <label class="label" for="ticket-evidence">Evidencia (opcional)</label>
        <div class="control">
          <input
            id="ticket-evidence"
            class="input"
            type="file"
            multiple
            accept="image/*,video/*,.pdf"
            ref="evidenceInput"
            @change="onEvidenceFilesChange"
          >
        </div>
        <p class="help">Puedes seleccionar una o varias imágenes, videos o PDFs.</p>
        <ul class="evidence-file-list" v-if="evidenceFiles.length">
          <li
            v-for="(file, index) in evidenceFiles"
            :key="`${file.name}-${index}`"
            class="evidence-file-list__item"
          >
            <span class="evidence-file-list__name">{{ file.name }}</span>
            <button
              type="button"
              class="evidence-file-list__remove"
              title="Quitar archivo"
              @click="removeEvidenceFile(index)"
            >
              <i class="fas fa-times"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'NewTicketForm',
  props: {
    moduleOptions: {
      type: Array,
      default: () => []
    },
    priorityOptions: {
      type: Array,
      default: () => []
    },
    typeOptions: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      subject: '',
      description: '',
      moduleCode: null,
      priorityCode: null,
      typeCode: null,
      caseUrl: '',
      evidenceFiles: []
    }
  },
  methods: {
    onEvidenceFilesChange (event) {
      const files = event.target.files ? Array.from(event.target.files) : []
      if (!files.length) {
        return
      }
      // El input nativo reemplaza la selección en cada @change, así que se
      // acumulan los archivos ya elegidos y se limpia el input para permitir
      // seguir agregando más sin perder los anteriores.
      this.evidenceFiles = this.evidenceFiles.concat(files)
      if (this.$refs.evidenceInput) {
        this.$refs.evidenceInput.value = null
      }
    },
    removeEvidenceFile (index) {
      this.evidenceFiles.splice(index, 1)
    },
    async submit () {
      if (!(await this.$validator.validateAll())) {
        return
      }
      this.$emit('submit', {
        subject: this.subject,
        description: this.description,
        moduleCode: this.moduleCode,
        priorityCode: this.priorityCode,
        typeCode: this.typeCode,
        caseUrl: this.caseUrl || null,
        evidenceFiles: this.evidenceFiles
      })
    },
    reset () {
      this.subject = ''
      this.description = ''
      this.moduleCode = null
      this.priorityCode = null
      this.typeCode = null
      this.caseUrl = ''
      this.evidenceFiles = []
      if (this.$refs.evidenceInput) {
        this.$refs.evidenceInput.value = null
      }
      this.$validator.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.evidence-file-list {
  margin-top: 0.5rem;
}

.evidence-file-list__item {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0.25rem 0;

  & + & {
    border-top: 1px solid #eceef2;
  }
}

.evidence-file-list__name {
  color: #5f7081;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-file-list__remove {
  background: none;
  border: none;
  color: #9aa5b4;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 12px;
  padding: 0 0.4rem;

  &:hover {
    color: #ff7979;
  }
}
</style>
